import React, { createContext, useContext, useState } from "react";

const WidgetContext = createContext();

export const useWidgetContext = () => {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error("useWidgetContext must be used within a WidgetProvider");
  }
  return context;
};

export const WidgetProvider = ({ children }) => {
  const [activeWidget, setActiveWidget] = useState(null); // 'ai', 'feedback', or null

  const openWidget = (widgetType) => {
    setActiveWidget(widgetType);
  };

  const closeWidget = (widgetType) => {
    if (activeWidget === widgetType) {
      setActiveWidget(null);
    }
  };

  const closeAllWidgets = () => {
    setActiveWidget(null);
  };

  return (
    <WidgetContext.Provider
      value={{
        activeWidget,
        openWidget,
        closeWidget,
        closeAllWidgets,
        isAIWidgetOpen: activeWidget === "ai",
        isFeedbackWidgetOpen: activeWidget === "feedback",
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
